import { FC, memo, useCallback } from 'react'

import { Button } from '@cash-me/react-components'
import { useRouter } from 'next/router'

import { Grid, Col } from 'components/grid'
import { Logo } from 'components/logo'
import { pushDataLayer } from 'utils/push-data-layer'

import * as S from './styles'

const Header: FC = memo(() => {
  const router = useRouter()

  const handleSiteButton = useCallback(() => {
    pushDataLayer({
      category: 'Clique',
      action: 'Header',
      label: 'Botão Ir para o site CashMe'
    })

    router.push('/')
  }, [router])

  return (
    <S.Wrapper>
      <Grid col={{ phone: 1, tablet: 1, desktop: 12 }}>
        <Col col={{ desktop: 10 }} start={{ desktop: 2 }}>
          <S.LogoWrapper>
            <Logo type="Cashme" width={7.375} height={1.375} />
            <Button onClick={handleSiteButton}>Ir para o Site CashMe</Button>
          </S.LogoWrapper>
        </Col>
      </Grid>
    </S.Wrapper>
  )
})

Header.displayName = 'Header'

export default Header
